import {hostName} from "../../../endpoint";
import {defaultHeaders} from "../../../headers";

export const createStaffList = async (users) => {
  try {
    const result = await fetch(`${hostName}/business/team-staffs`, {
      method: "POST",
      headers: {
        ...defaultHeaders,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
      body: JSON.stringify(users),
    });
    return {
      hasSuccess: result.status === 200,
      data: await result.json(),
    };
  } catch (err) {
    return {
      hasSuccess: false,
      data: err.message,
    };
  }
};
